var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('docs-wrapper',{attrs:{"link":_vm.currentPageSlug,"page":_vm.selectedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }